import { useEffect } from "react";
import { api } from "../../utils/api";
import { API_ROUTES } from "../../routes/apiRoutes";
import useReportStepperStore from "../../pages/Reports/Stepper/reportSidebarStore";

// Hook to fetch and process sidebar data for the report stepper
export function useReportSidebarData(overviewId) {
  const sidebarData = useReportStepperStore((s) => s.sidebarData);
  const setSidebarData = useReportStepperStore((s) => s.setSidebarData);
  // You can add loading/error state to the store if needed
  const loading = false;
  const error = null;

  useEffect(() => {
    if (!overviewId) {
      setSidebarData([]);
      return;
    }
    async function fetchSidebarData() {
      try {
        const response = await api.get(API_ROUTES.REPORT_STEPPER(overviewId));
        const apiData = response.data?.data || [];
        setSidebarData(apiData);
      } catch (err) {
        // You can add error handling here if you add error state to the store
        // setError(err.message);
      } finally {
        // setLoading(false);
      }
    }
    fetchSidebarData();
    // eslint-disable-next-line
  }, [overviewId]);

  return { sidebarData, loading, error };
}
